/**
 * @readonly
 * @enum {import("./interfaces").State}
 */
const STATUSES = {
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success'
}
/**
 * @readonly
 * @enum {import("./interfaces").Size}
 */
const SIZES = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small'
}
/**
 * @readonly
 * @enum {import("./interfaces").ArrowDirection}
 */
const ARROW = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
}

export {
  SIZES,
  STATUSES,
  ARROW
}
